// The staff page frame (010 revision 2, FR-046; revision 5, FR-053 on the shared PageContainer): every screen renders
// its content in this one `main`: the page gutter of the breakpoint (16, 24 or 32 px), the system's vertical rhythm and
// the content width (at most 1440 px). The UI checks measure the gutters from the element marked `data-ui-content`
// (ui-check.config.json). Revision 6 (FR-072, 000 FR-130): the density formula's page: sections 16 px apart
// (`gap-section`), the gutter at the sides and the page top above; screens no longer choose the gap.
import { PageContainer } from '@arcel/ui/shell';
import type { ReactNode } from 'react';

/** Props of {@link StaffPage}. */
export interface StaffPageProps {
  children: ReactNode;
  /** Extra classes that do not change the page's padding (for example `relative`). */
  className?: string;
  /** Accessible name of the page, when its heading does not name it. */
  label?: string;
  /** `viewport`: the page fits the window from 1024 px (the App demo; the UI check's `fit-viewport` rule). */
  fit?: 'viewport';
}

/**
 * The page frame of a staff screen.
 * @param props the content, extra classes, an optional accessible name and whether the page fits the window
 * @returns the `main` element with the shared gutters
 */
export function StaffPage({ children, className, label, fit }: StaffPageProps) {
  return (
    <PageContainer data-ui-content="" data-ui-fit={fit} aria-label={label} className={className}>
      {children}
    </PageContainer>
  );
}
